import { BriefDisplayStatus } from '@fiverr-private/dynamic_matching';
import { isCurrentUser } from '../../../../../lib/utils/getters';
import { BriefAction, BriefItem } from '../../../../../lib/types/brief';

export const calculateAction = (brief: BriefItem): BriefAction => {
    const isUserOwner = isCurrentUser(brief.createdBy.id);

    if (!isUserOwner) {
        return BriefAction.VIEW_BRIEF;
    }

    if (brief.type === 'agentic') {
        // Agentic briefs have no invite flow — owners manage them on the brief view page.
        return brief.briefDisplayStatus === BriefDisplayStatus.REJECTED
            ? BriefAction.VIEW_BRIEF
            : BriefAction.MANAGE_BRIEF;
    }

    switch (brief.briefDisplayStatus) {
        case BriefDisplayStatus.REJECTED: {
            return BriefAction.VIEW_BRIEF;
        }

        case BriefDisplayStatus.NO_INVITES_SENT: {
            return BriefAction.INVITE_FREELANCERS;
        }

        default:
            return BriefAction.MANAGE_BRIEF;
    }
};
